import { render, staticRenderFns } from "./Card-pumkm.vue?vue&type=template&id=6908c878&scoped=true&"
import script from "./Card-pumkm.vue?vue&type=script&lang=js&"
export * from "./Card-pumkm.vue?vue&type=script&lang=js&"
import style0 from "./Card-pumkm.vue?vue&type=style&index=0&id=6908c878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6908c878",
  null
  
)

export default component.exports